import React from 'react';
import styled from '@emotion/styled';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
`

const Title = styled.h1`
  color: #4CAF50;
  margin-bottom: 2rem;
`

const Section = styled.section`
  margin-bottom: 2rem;
`

function Privacy() {
  return (
    <Container>
      <Title>Privacy Policy</Title>
      
      <Section>
        <h2>Information We Collect</h2>
        <p>
          We collect location data only when you explicitly search for farmers markets. 
          This information is used solely to provide you with relevant market locations 
          in your area. We do not store your location data or search history.
        </p>
      </Section>

      <Section>
        <h2>How We Use Your Information</h2>
        <p>
          Your location data is used only to:
        </p>
        <ul>
          <li>Find farmers markets near you</li>
          <li>Display relevant market information</li>
          <li>Provide directions to markets</li>
        </ul>
      </Section>

      <Section>
        <h2>Third-Party Services</h2>
        <p>
          We use Google Maps API to provide location services and market information. 
          Please refer to Google's privacy policy for information about how they handle data.
        </p>
      </Section>

      <Section>
        <h2>Data Security</h2>
        <p>
          We prioritize the security of your information and do not store any personal data. 
          All location searches are performed in real-time and are not saved on our servers.
        </p>
      </Section>

      <Section>
        <h2>Updates to Privacy Policy</h2>
        <p>
          We may update this privacy policy from time to time. Any changes will be posted 
          on this page with an updated revision date.
        </p>
      </Section>
    </Container>
  );
}

export default Privacy;
